import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Skeleton from 'app/components/base/Skeleton'
import Text, { TextProps } from 'app/components/base/Text'
import ReportLink from 'app/components/common/ReportLink'
import { REPORT_TYPE } from 'app/utils/constants/status.constants'

interface ReportUserBlockProps {
  userId: string
  loading?: boolean
  hideBlock?: boolean
  sxText?: TextProps['sx']
}

const ReportUserBlock: RFC<ReportUserBlockProps> = ({
  userId,
  loading,
  hideBlock = false,
  sxText
}) => {
  const link = (chunk: React.ReactNode[]): React.ReactNode => (
    <ReportLink
      id={userId}
      type={REPORT_TYPE.user}
      sx={{
        fontWeight: 500,
        color: 'primary.main',
        ...Platform.select({
          web: {
            display: 'inline-flex'
          }
        })
      }}
    >
      {chunk}
    </ReportLink>
  )

  return (
    <>
      {!hideBlock && (
        <Skeleton loading={loading} width="80%" sx={{ mt: { xs: 2, md: 3 } }}>
          <Text
            component="div"
            variant="body2"
            sx={{ color: 'text.third', mt: { xs: 2, md: 3 }, ...sxText }}
          >
            <FormattedMessage
              defaultMessage="Against the sale or site rules? <link>Report a User</link>"
              values={{ link }}
            />
          </Text>
        </Skeleton>
      )}
    </>
  )
}

export default ReportUserBlock
